import React from "react";
import {Result} from "antd";
import {
    ToolOutlined,
} from '@ant-design/icons';
import './Stats.less';
import PageHeader from "../views/PageHeader";
import Div from "../views/Div";

export default class Stats extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            leftRouterState: false,
        };
    }

    render() {
        return (
            <div className='Stats'>
                <PageHeader title='Статистика'/>
                <Div>
                    <Result
                        icon={<ToolOutlined fill='#1890ff' />}
                        title="В разработке"
                    />
                </Div>
            </div>
        );
    }
}